"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file assets.proto (package assets, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetService = void 0;
const assets_pb_js_1 = require("./assets_pb.js");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service assets.AssetService
 */
exports.AssetService = {
    typeName: "assets.AssetService",
    methods: {
        /**
         * @generated from rpc assets.AssetService.GetAsset
         */
        getAsset: {
            name: "GetAsset",
            I: assets_pb_js_1.GetAssetRequest,
            O: assets_pb_js_1.GetAssetResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.UploadAsset
         */
        uploadAsset: {
            name: "UploadAsset",
            I: assets_pb_js_1.UploadAssetRequest,
            O: assets_pb_js_1.UploadAssetResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.ListAssets
         */
        listAssets: {
            name: "ListAssets",
            I: assets_pb_js_1.ListAssetsRequest,
            O: assets_pb_js_1.ListAssetsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.GetHash
         */
        getHash: {
            name: "GetHash",
            I: assets_pb_js_1.GetHashRequest,
            O: assets_pb_js_1.GetHashResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.BuildPack
         */
        buildPack: {
            name: "BuildPack",
            I: assets_pb_js_1.BuildPackRequest,
            O: assets_pb_js_1.BuildPackResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.CreateCategory
         */
        createCategory: {
            name: "CreateCategory",
            I: assets_pb_js_1.CreateCategoryRequest,
            O: assets_pb_js_1.CreateCategoryResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.DeletePack
         */
        deletePack: {
            name: "DeletePack",
            I: assets_pb_js_1.DeletePackRequest,
            O: assets_pb_js_1.DeletePackResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.GetCategory
         */
        getCategory: {
            name: "GetCategory",
            I: assets_pb_js_1.GetCategoryRequest,
            O: assets_pb_js_1.GetCategoryResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.UploadPack
         */
        uploadPack: {
            name: "UploadPack",
            I: assets_pb_js_1.UploadPackRequest,
            O: assets_pb_js_1.UploadPackResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.GetImages
         */
        getImages: {
            name: "GetImages",
            I: assets_pb_js_1.GetUploadedImagesRequest,
            O: assets_pb_js_1.GetUploadedImagesResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.UploadImage
         */
        uploadImage: {
            name: "UploadImage",
            I: assets_pb_js_1.UploadImageRequest,
            O: assets_pb_js_1.UploadImageResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.DeleteImage
         */
        deleteImage: {
            name: "DeleteImage",
            I: assets_pb_js_1.DeleteImageRequest,
            O: assets_pb_js_1.DeleteImageResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.RebuildCorePack
         */
        rebuildCorePack: {
            name: "RebuildCorePack",
            I: assets_pb_js_1.RebuildCorePackRequest,
            O: assets_pb_js_1.RebuildCorePackResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc assets.AssetService.SyncCorePack
         */
        syncCorePack: {
            name: "SyncCorePack",
            I: assets_pb_js_1.SyncCorePackRequest,
            O: assets_pb_js_1.SyncCorePackResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
